import React, { useEffect, useState } from "react";
import { Field } from "redux-form";
import {
  renderTextField,
  renderOptionField,
  renderTextFieldPreValue,
} from "../formcomponents";
import { Button, Grid, Table } from "semantic-ui-react";
import axios from "axios";
import { BaseUrlInvoice } from "../formcomponents/Constants";
const NewInvoiceFieldArr = ({
  fields,
  totalAmountSum,
  itemCategory,
  meta: { touched, error, submitFailed },
}) => {
  const [total, setTotal] = useState([]);
  const [finalAmount, setFinalAmount] = useState([]);
  const [unitPrice, setUnitPrice] = useState([]);
  const [quantity, setQuantity] = useState([]);
  const [discount, setDiscount] = useState([]);
  const [totalAmount, setTotalAmount] = useState();
  const [selectedCurrency, setselectedCurrency] = useState("AED");
  const currencyOption = [
    { text: "AED", value: "AED" },
    { text: "EUR", value: "EUR" },
    { text: "USD", value: "USD" },
    { text: "INR", value: "INR" },
  ];

  const currencyConversion = [
    { option: "AED", value: 1 },
    { option: "EUR", value: 3.93 },
    { option: "USD", value: 3.67 },
    { option: "INR", value: 22.59 },
  ];

  const statusVal = [
    { text: "Tickets Sent", value: 1 },
    { text: "Invoice Generated", value: 2 },
    { text: "Amount Received", value: 3 },
  ];

  useEffect(() => {
    console.log(totalAmountSum);
    getWorkCatList();
  }, []);

  const [itemDesList, setitemDesList] = useState([]);
  const getWorkCatList = async () => {
    await axios
      .post(BaseUrlInvoice + "/accounts/listSSCategory", {
        categoryType: 999765,
      })
      .then((res) => {
        console.log("res", res.data);
        const resData = res.data;
        let tempList = [];
        for (let i = 0; i < resData.length; i++) {
          tempList.push({
            text: resData[i].categoryName,
            value: resData[i].categoryName,
          });
        }
        setitemDesList(tempList);
      })
      .catch((error) => console.log(error));
  };

  const calculateTotal = (index, label, value) => {
    if (label === "quantity") {
      setQuantity((prevQuantity) => {
        const newQuantity = [...prevQuantity];
        newQuantity[index] = value;
        return newQuantity;
      });
    } else if (label === "unitPrice") {
      setUnitPrice((prevUnitPrice) => {
        const newUnitPrice = [...prevUnitPrice];
        newUnitPrice[index] = value;
        return newUnitPrice;
      });
    } else if (label === "discount") {
      setDiscount((prevDiscount) => {
        const newDiscount = [...prevDiscount];
        newDiscount[index] = value;
        return newDiscount;
      });
    } else if (label === "currency") {
      const selectedCurrencyValue =
        currencyConversion.find((cur) => cur.option === value)?.value || 1;

      setselectedCurrency(value);
      const convertedAmounts = total.map((amount, i) => {
        const itemQuantity = quantity[i] || 0;
        const itemUnitPrice = unitPrice[i] || 0;
        const itemDiscount = discount[i] || 0;
        const itemTaxRate = 0;

        const amountBeforeTax = itemQuantity * itemUnitPrice - itemDiscount;
        const amountWithTax = amountBeforeTax + amountBeforeTax * itemTaxRate;

        const convertedAmount = amountWithTax * selectedCurrencyValue;
        return parseFloat(convertedAmount.toFixed(2));
      });

      setFinalAmount(convertedAmounts);
    }
  };

  useEffect(() => {
    const tempTotal = quantity.map((qty, index) => {
      const price = unitPrice[index] || 0;
      return qty * price;
    });

    setTotal(tempTotal);
  }, [quantity, unitPrice]);

  useEffect(() => {
    const calculatedFinalAmount = total.map((amount, index) => {
      const disc = discount[index] || 0;
      const tax = 0;

      // Calculate the amount before tax
      const amountBeforeTax = Number(amount) - Number(disc);

      // Calculate the final amount with tax applied
      const amountWithTax = amountBeforeTax + amountBeforeTax * tax;

      return parseFloat(amountWithTax.toFixed(2)); // Round to 2 decimal places
    });

    const sum = calculatedFinalAmount.reduce(
      (accumulator, value) => accumulator + value,
      0
    );
    setTotalAmount(sum);
    setFinalAmount(calculatedFinalAmount);
  }, [total, discount]);

  useEffect(() => {}, [finalAmount, totalAmount]);

  // const calculateGrandTotal = () => {
  //   return finalAmount.reduce((acc, val) => acc + val, 0).toFixed(2);
  // };

  const calculateGrandTotal = () => {
    let grandTotal = finalAmount.reduce((acc, val) => acc + val, 0);
    if (totalAmountSum) {
      grandTotal += parseFloat(totalAmountSum);
    }
    return grandTotal.toFixed(2);
  };

  return (
    <>
      <Grid columns={10}>
        <Grid.Row>
          <Grid.Column width={2}>Attractions</Grid.Column>
          <Grid.Column width={3}>Item Description</Grid.Column>
          {/* <Grid.Column width={2}>Status</Grid.Column> */}
          <Grid.Column width={1.5}>Quantity</Grid.Column>
          <Grid.Column width={1.5}>Unit Price</Grid.Column>
          <Grid.Column width={1.5}>Recived Money</Grid.Column>
          <Grid.Column width={1.5}>Currency</Grid.Column>
          <Grid.Column width={2}>Amount</Grid.Column>
          <Grid.Column width={1}>Actions</Grid.Column>
        </Grid.Row>

        {fields.map((item, index) => (
          <Grid.Row key={index}>
            <Grid.Column width={2}>
              <Field
                name={`${item}.itemName`}
                type="text"
                options={itemDesList}
                //itemDesList
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column width={3}>
              <Field
                name={`${item}.itemDescription`}
                type="text"
                component={renderTextField}
              />
            </Grid.Column>

            {/* <Grid.Column width={2}>
              <Field
                name={`${item}.status`}
                options={statusVal}
                component={renderOptionField}
              />
            </Grid.Column> */}
            <Grid.Column width={1.5}>
              <Field
                name={`${item}.itemQty`}
                type="text"
                onChange={(e) =>
                  calculateTotal(index, "quantity", e.target.value)
                }
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column width={1.5}>
              <Field
                name={`${item}.unitPrice`}
                type="text"
                onChange={(e) =>
                  calculateTotal(index, "unitPrice", e.target.value)
                }
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column width={1.5}>
              <Field
                name={`${item}.disPer`}
                type="text"
                onChange={(e) =>
                  calculateTotal(index, "discount", e.target.value)
                }
                component={renderTextField}
              />
            </Grid.Column>
            <Grid.Column width={1.5}>
              <Field
                name={`${item}.currency`}
                options={currencyOption}
                onChange={(e) => calculateTotal(index, "currency", e)}
                component={renderOptionField}
              />
            </Grid.Column>
            <Grid.Column width={2}>
              <Field
                name={`${item}.amount`}
                type="text"
                fieldValue={finalAmount[index] || 0}
                component={renderTextFieldPreValue}
              />{" "}
            </Grid.Column>
            <Grid.Column width={1}>
              <Button
                type="button"
                floated="left"
                negative
                onClick={() => fields.remove(index)}
              >
                X
              </Button>
            </Grid.Column>
          </Grid.Row>
        ))}

        {totalAmountSum !== "" && (
          <Grid.Row>
            <Grid.Column width={16}>
              <Button
                type="button"
                positive
                floated="left"
                onClick={() => fields.push({ taxRate: 0 })}
              >
                Add More
              </Button>
            </Grid.Column>
          </Grid.Row>
        )}

        <Grid.Row>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={3}></Grid.Column>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}></Grid.Column>
          <Grid.Column width={2}>
            {" "}
            <h3>Total</h3>
          </Grid.Column>
          <Grid.Column width={2}>
            {" "}
            {/* {totalAmountSum ? totalAmountSum : calculateGrandTotal()} */}
            {calculateGrandTotal()}
          </Grid.Column>
          <Grid.Column width={1}></Grid.Column>
        </Grid.Row>
      </Grid>
    </>
  );
};

export default NewInvoiceFieldArr;
